define("media/components/media/asset-filter", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@glimmer/tracking", "@ember/object", "@ember/object/computed", "@ember/service", "@ember/utils", "later/lib/filter-by-fields", "later/utils/constants"], function (_exports, _component, _templateFactory, _component2, _tracking, _object, _computed, _service, _utils, _filterByFields, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="cMF--filter">
    {{!  Header }}
    <div class="cMF--filter__header">
      {{#if @isBeingFiltered}}
        <Shared::Ui::Button
          @class="qa--mediaLib_clearFilter_btn"
          @text={{t "media_library.filter.clear"}}
          @onClick={{@clearAllFilters}}
        />
      {{else}}
        <div class="cMF--filter__headerTitle">
          {{svg-jar "filter" class="o--icon u--m__r__xs"}}
          {{t "media_library.filter.title"}}
        </div>
      {{/if}}
    </div>
    <ul class="cMF--filter__content eMF--scrollContainer" {{perfect-scroll}}>
      {{!  Media Notes }}
      <li class="cMF--filter__category">
        <h5 class="cMF--filter__title">
          {{t "media_library.filter.media_notes"}}
        </h5>
        <div class="o--formWrapper">
          <div class="o--inputAction--light u--p__r__xs">
            {{svg-jar "search" class="o--icon o--inputAction__icon--left"}}
            <Input
              @id="mediaNoteSearch"
              @class="o--inputAction__input u--p__r__md qa--mediaLib_notes_input"
              @placeholder={{t "media_library.filter.search_placeholder"}}
              @type="search"
              @value={{@searchString}}
              @enter={{@searchMediaNotes}}
              {{autofocus}}
            />
            {{#if @hasSearchTerms}}
              <span {{on "click" @clearMediaSearch}}>
                {{svg-jar "close" class="o--icon o--inputAction__icon--right u--fadeIn--right"}}
              </span>
            {{/if}}
          </div>
        </div>
      </li>
      {{!  Media Usage }}
      <li class="cMF--filter__category">
        <h5 class="cMF--filter__title">
          {{t "media_library.filter.media_usage"}}
        </h5>
        <Shared::Media::Filter::FilterMediaUsage @usedUnused={{@usedUnused}} @setUsedUnused={{@setUsedUnused}} />
        {{#if this.showSocialProfileFilter}}
          <Shared::Media::Filter::FilterProfile
            @group={{@group}}
            @selectedSocialProfileIds={{@querySocialProfileIds}}
            @toggleSocialProfile={{this.toggleSocialProfile}}
          />
        {{/if}}
      </li>
      {{!  Media Type }}
      <li class="cMF--filter__category">
        <h5 class="cMF--filter__title">
          {{t "media_library.filter.media_type"}}
        </h5>
        {{!  Filter by  Media Type }}
        <Shared::Media::Filter::FilterMediaType
          @mediaTypeFilter={{@mediaTypeFilter}}
          @setMediaTypeFilter={{@setMediaTypeFilter}}
        />
      </li>
      {{!  Time Uploaded }}
      <li class="cMF--filter__category">
        <h5 class="cMF--filter__title">
          {{t "media_library.filter.time_uploaded"}}
        </h5>
        <div class="o--formWrapper">
          <Shared::Media::Filter::FilterDateRange
            @selectedDateRange={{@setDateFilter}}
            @updateDateRange={{@updateDateFilter}}
          />
        </div>
      </li>
      {{!  Label List }}
      {{#if this.sortedSystemLabels.length}}
        {{!  System Labels }}
        <li class="cMF--filter__category">
          <h5 class="cMF--filter__title">
            {{t "media_library.filter.system_labels"}}
            <span>
              {{svg-jar "help" class="o--icon o--icon--light"}}
              <EmberTooltip @delay={{330}} @side="top">
                {{t "media_library.filter.system_labels_tooltip"}}
              </EmberTooltip>
            </span>
          </h5>
          {{#each this.sortedToggledSystemLabels as |systemLabel|}}
            <div class="cLB--filter__item">
              <div
                class="cLB--label cLB--label--system u--ellipsis
                  {{if systemLabel.selected "is--active"}}
                  qa--systemLabel__{{systemLabel.qaClassName}}"
                {{on "click" (fn this.toggleLabel systemLabel.id)}}
              >
                {{#if systemLabel.selected}}
                  {{svg-jar "check" class="o--icon o--icon--success"}}
                {{/if}}
                <span>
                  {{systemLabel.canonicalTagName}}
                </span>
                <span class="cLB--label__counter">
                  {{systemLabel.taggedCount}}
                </span>
              </div>
            </div>
          {{/each}}
        </li>
      {{/if}}
      {{!  User Labels }}
      <li class="cMF--filter__category">
        <h5 class="cMF--filter__title">
          {{t "media_library.filter.my_labels"}}
          {{! Label Dropdown }}
          <Shared::Ui::Button
            @class="is--actionLink u--text--sm u--text--uppercase u--float--right qa--mediaLib_manageLabel_link"
            @text={{t "media_library.filter.manage"}}
            @type="unstyled"
            @onClick={{this.openManageLabelsModal}}
          />
        </h5>
        <div class="o--formWrapper">
          <div class="o--inputAction u--p__r__xs">
            {{svg-jar "search" class="o--icon o--inputAction__icon--left"}}
            <Input
              class="o--inputAction__input u--p__r__md qa--mediaLib_myLabel_inputbx"
              placeholder={{t "media_library.filter.search_labels"}}
              @type="search"
              @value={{this.labelSearchString}}
            />
            {{#if this.isSearchingLabels}}
              <span {{on "click" this.clearLabelSearch}}>
                {{svg-jar "close" class="o--icon o--inputAction__icon--right u--fadeIn--right"}}
              </span>
            {{/if}}
          </div>
        </div>
        {{!  Label List: Note: Limit Labels to 5}}
        {{#each this.sortedToggledUserLabels as |userLabel|}}
          <div class="cLB--filter__item">
            <div
              class="cLB--label u--ellipsis qa--mediaLib_labelFilter {{if userLabel.selected "is--active"}}"
              {{on "click" (fn this.toggleLabel userLabel.id)}}
            >
              {{#if userLabel.selected}}
                {{svg-jar "check" class="o--icon o--icon--success"}}
              {{/if}}
              <span>
                {{userLabel.canonicalTagName}}
              </span>
              <span class="cLB--label__counter">
                {{userLabel.taggedCount}}
              </span>
            </div>
          </div>
        {{/each}}
        {{!  Show More }}
        {{#if this.showLoadMoreLabels}}
          <a class="o--btn--sm o--btn--block u--text--center u--m__tb__xs" {{on "click" this.toggleAllLabels}}>
            {{#if this.showAllLabels}}
              {{t "media_library.filter.show_less"}}
            {{else}}
              {{t "media_library.filter.show_all"}}{{svg-jar "caret-down" class="o--icon--sm"}}
            {{/if}}
          </a>
        {{/if}}
      </li>
    </ul>
  </div>
  {{#if this.showManageLabelsModal}}
    <Media::ManageLabels
      @labels={{this.nonSystemLabels}}
      @showManageLabelsModal={{this.showManageLabelsModal}}
      @closeManageLabelsModal={{this.closeManageLabelsModal}}
      @addNewLabel={{@addNewLabel}}
    />
  {{/if}}
  */
  {
    "id": "3iM8TTin",
    "block": "[[[10,0],[14,0,\"cMF--filter\"],[12],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"cMF--filter__header\"],[12],[1,\"\\n\"],[41,[30,1],[[[1,\"      \"],[8,[39,1],null,[[\"@class\",\"@text\",\"@onClick\"],[\"qa--mediaLib_clearFilter_btn\",[28,[37,2],[\"media_library.filter.clear\"],null],[30,2]]],null],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,0],[14,0,\"cMF--filter__headerTitle\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"filter\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n        \"],[1,[28,[35,2],[\"media_library.filter.title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n  \"],[11,\"ul\"],[24,0,\"cMF--filter__content eMF--scrollContainer\"],[4,[38,4],null,null],[12],[1,\"\\n\"],[1,\"    \"],[10,\"li\"],[14,0,\"cMF--filter__category\"],[12],[1,\"\\n      \"],[10,\"h5\"],[14,0,\"cMF--filter__title\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"media_library.filter.media_notes\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"o--inputAction--light u--p__r__xs\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"search\"],[[\"class\"],[\"o--icon o--inputAction__icon--left\"]]]],[1,\"\\n          \"],[8,[39,5],[[4,[38,6],null,null]],[[\"@id\",\"@class\",\"@placeholder\",\"@type\",\"@value\",\"@enter\"],[\"mediaNoteSearch\",\"o--inputAction__input u--p__r__md qa--mediaLib_notes_input\",[28,[37,2],[\"media_library.filter.search_placeholder\"],null],\"search\",[30,3],[30,4]]],null],[1,\"\\n\"],[41,[30,5],[[[1,\"            \"],[11,1],[4,[38,7],[\"click\",[30,6]],null],[12],[1,\"\\n              \"],[1,[28,[35,3],[\"close\"],[[\"class\"],[\"o--icon o--inputAction__icon--right u--fadeIn--right\"]]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[1,\"    \"],[10,\"li\"],[14,0,\"cMF--filter__category\"],[12],[1,\"\\n      \"],[10,\"h5\"],[14,0,\"cMF--filter__title\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"media_library.filter.media_usage\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,8],null,[[\"@usedUnused\",\"@setUsedUnused\"],[[30,7],[30,8]]],null],[1,\"\\n\"],[41,[30,0,[\"showSocialProfileFilter\"]],[[[1,\"        \"],[8,[39,9],null,[[\"@group\",\"@selectedSocialProfileIds\",\"@toggleSocialProfile\"],[[30,9],[30,10],[30,0,[\"toggleSocialProfile\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\"],[1,\"    \"],[10,\"li\"],[14,0,\"cMF--filter__category\"],[12],[1,\"\\n      \"],[10,\"h5\"],[14,0,\"cMF--filter__title\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"media_library.filter.media_type\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"],[1,\"      \"],[8,[39,10],null,[[\"@mediaTypeFilter\",\"@setMediaTypeFilter\"],[[30,11],[30,12]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"],[1,\"    \"],[10,\"li\"],[14,0,\"cMF--filter__category\"],[12],[1,\"\\n      \"],[10,\"h5\"],[14,0,\"cMF--filter__title\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"media_library.filter.time_uploaded\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n        \"],[8,[39,11],null,[[\"@selectedDateRange\",\"@updateDateRange\"],[[30,13],[30,14]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[30,0,[\"sortedSystemLabels\",\"length\"]],[[[1,\"      \"],[10,\"li\"],[14,0,\"cMF--filter__category\"],[12],[1,\"\\n        \"],[10,\"h5\"],[14,0,\"cMF--filter__title\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"media_library.filter.system_labels\"],null]],[1,\"\\n          \"],[10,1],[12],[1,\"\\n            \"],[1,[28,[35,3],[\"help\"],[[\"class\"],[\"o--icon o--icon--light\"]]]],[1,\"\\n            \"],[8,[39,12],null,[[\"@delay\",\"@side\"],[330,\"top\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,2],[\"media_library.filter.system_labels_tooltip\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"],[42,[28,[37,14],[[28,[37,14],[[30,0,[\"sortedToggledSystemLabels\"]]],null]],null],null,[[[1,\"          \"],[10,0],[14,0,\"cLB--filter__item\"],[12],[1,\"\\n            \"],[11,0],[16,0,[29,[\"cLB--label cLB--label--system u--ellipsis\\n                \",[52,[30,15,[\"selected\"]],\"is--active\"],\"\\n                qa--systemLabel__\",[30,15,[\"qaClassName\"]]]]],[4,[38,7],[\"click\",[28,[37,15],[[30,0,[\"toggleLabel\"]],[30,15,[\"id\"]]],null]],null],[12],[1,\"\\n\"],[41,[30,15,[\"selected\"]],[[[1,\"                \"],[1,[28,[35,3],[\"check\"],[[\"class\"],[\"o--icon o--icon--success\"]]]],[1,\"\\n\"]],[]],null],[1,\"              \"],[10,1],[12],[1,\"\\n                \"],[1,[30,15,[\"canonicalTagName\"]]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,1],[14,0,\"cLB--label__counter\"],[12],[1,\"\\n                \"],[1,[30,15,[\"taggedCount\"]]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[15]],null],[1,\"      \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[10,\"li\"],[14,0,\"cMF--filter__category\"],[12],[1,\"\\n      \"],[10,\"h5\"],[14,0,\"cMF--filter__title\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"media_library.filter.my_labels\"],null]],[1,\"\\n\"],[1,\"        \"],[8,[39,1],null,[[\"@class\",\"@text\",\"@type\",\"@onClick\"],[\"is--actionLink u--text--sm u--text--uppercase u--float--right qa--mediaLib_manageLabel_link\",[28,[37,2],[\"media_library.filter.manage\"],null],\"unstyled\",[30,0,[\"openManageLabelsModal\"]]]],null],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"o--inputAction u--p__r__xs\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"search\"],[[\"class\"],[\"o--icon o--inputAction__icon--left\"]]]],[1,\"\\n          \"],[8,[39,5],[[24,0,\"o--inputAction__input u--p__r__md qa--mediaLib_myLabel_inputbx\"],[16,\"placeholder\",[28,[37,2],[\"media_library.filter.search_labels\"],null]]],[[\"@type\",\"@value\"],[\"search\",[30,0,[\"labelSearchString\"]]]],null],[1,\"\\n\"],[41,[30,0,[\"isSearchingLabels\"]],[[[1,\"            \"],[11,1],[4,[38,7],[\"click\",[30,0,[\"clearLabelSearch\"]]],null],[12],[1,\"\\n              \"],[1,[28,[35,3],[\"close\"],[[\"class\"],[\"o--icon o--inputAction__icon--right u--fadeIn--right\"]]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"],[42,[28,[37,14],[[28,[37,14],[[30,0,[\"sortedToggledUserLabels\"]]],null]],null],null,[[[1,\"        \"],[10,0],[14,0,\"cLB--filter__item\"],[12],[1,\"\\n          \"],[11,0],[16,0,[29,[\"cLB--label u--ellipsis qa--mediaLib_labelFilter \",[52,[30,16,[\"selected\"]],\"is--active\"]]]],[4,[38,7],[\"click\",[28,[37,15],[[30,0,[\"toggleLabel\"]],[30,16,[\"id\"]]],null]],null],[12],[1,\"\\n\"],[41,[30,16,[\"selected\"]],[[[1,\"              \"],[1,[28,[35,3],[\"check\"],[[\"class\"],[\"o--icon o--icon--success\"]]]],[1,\"\\n\"]],[]],null],[1,\"            \"],[10,1],[12],[1,\"\\n              \"],[1,[30,16,[\"canonicalTagName\"]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,1],[14,0,\"cLB--label__counter\"],[12],[1,\"\\n              \"],[1,[30,16,[\"taggedCount\"]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[16]],null],[41,[30,0,[\"showLoadMoreLabels\"]],[[[1,\"        \"],[11,3],[24,0,\"o--btn--sm o--btn--block u--text--center u--m__tb__xs\"],[4,[38,7],[\"click\",[30,0,[\"toggleAllLabels\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"showAllLabels\"]],[[[1,\"            \"],[1,[28,[35,2],[\"media_library.filter.show_less\"],null]],[1,\"\\n\"]],[]],[[[1,\"            \"],[1,[28,[35,2],[\"media_library.filter.show_all\"],null]],[1,[28,[35,3],[\"caret-down\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n\"]],[]]],[1,\"        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"],[41,[30,0,[\"showManageLabelsModal\"]],[[[1,\"  \"],[8,[39,16],null,[[\"@labels\",\"@showManageLabelsModal\",\"@closeManageLabelsModal\",\"@addNewLabel\"],[[30,0,[\"nonSystemLabels\"]],[30,0,[\"showManageLabelsModal\"]],[30,0,[\"closeManageLabelsModal\"]],[30,17]]],null],[1,\"\\n\"]],[]],null]],[\"@isBeingFiltered\",\"@clearAllFilters\",\"@searchString\",\"@searchMediaNotes\",\"@hasSearchTerms\",\"@clearMediaSearch\",\"@usedUnused\",\"@setUsedUnused\",\"@group\",\"@querySocialProfileIds\",\"@mediaTypeFilter\",\"@setMediaTypeFilter\",\"@setDateFilter\",\"@updateDateFilter\",\"systemLabel\",\"userLabel\",\"@addNewLabel\"],false,[\"if\",\"shared/ui/button\",\"t\",\"svg-jar\",\"perfect-scroll\",\"input\",\"autofocus\",\"on\",\"shared/media/filter/filter-media-usage\",\"shared/media/filter/filter-profile\",\"shared/media/filter/filter-media-type\",\"shared/media/filter/filter-date-range\",\"ember-tooltip\",\"each\",\"-track-array\",\"fn\",\"media/manage-labels\"]]",
    "moduleName": "media/components/media/asset-filter.hbs",
    "isStrictMode": false
  });

  let AssetFilterComponent = (_dec = (0, _computed.sort)('groupLabels', 'labelSorting'), _dec2 = (0, _computed.sort)('nonSystemLabels', 'labelSorting'), _dec3 = (0, _computed.sort)('systemLabels', 'labelSorting'), (_class = class AssetFilterComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "labelSearchString", _descriptor2, this);

      _initializerDefineProperty(this, "showAllLabels", _descriptor3, this);

      _initializerDefineProperty(this, "showManageLabelsModal", _descriptor4, this);

      _initializerDefineProperty(this, "sortedGroupLabels", _descriptor5, this);

      _initializerDefineProperty(this, "sortedNonSystemLabels", _descriptor6, this);

      _initializerDefineProperty(this, "sortedSystemLabels", _descriptor7, this);

      _defineProperty(this, "labelSorting", ['taggedCount:desc']);

      this.labelSearchString = undefined;
      this.showAllLabels = false;
      this.showManageLabelsModal = false;
    }

    get groupLabels() {
      var _this$args$group;

      return (_this$args$group = this.args.group) === null || _this$args$group === void 0 ? void 0 : _this$args$group.labels;
    }

    get isSearchingLabels() {
      return !(0, _utils.isEmpty)(this.labelSearchString);
    }

    get nonSystemLabels() {
      var _this$groupLabels;

      return (_this$groupLabels = this.groupLabels) === null || _this$groupLabels === void 0 ? void 0 : _this$groupLabels.filter(label => !label.isSystemLabel);
    }

    get nonSystemLabelCount() {
      var _this$nonSystemLabels;

      return (_this$nonSystemLabels = this.nonSystemLabels) === null || _this$nonSystemLabels === void 0 ? void 0 : _this$nonSystemLabels.length;
    }

    get showLoadMoreLabels() {
      if (!this.nonSystemLabelCount) {
        return false;
      }

      return !this.isSearchingLabels && this.nonSystemLabelCount > _constants.MEDIA_LABEL_DEFAULT_DISPLAY_LIMIT;
    }

    get showSocialProfileFilter() {
      return this.args.usedUnused === 'used' || this.args.usedUnused === 'unused';
    }

    get sortedToggledSystemLabels() {
      const labels = this.showAllLabels ? this.sortedSystemLabels : this.sortedSystemLabels.slice(0, _constants.MEDIA_LABEL_DEFAULT_DISPLAY_LIMIT);
      return labels.map(label => {
        const labelId = label.id;
        return {
          id: labelId,
          selected: this.args.queryLabelIds.includes(parseInt(labelId)),
          canonicalTagName: label.canonicalTagName,
          taggedCount: label.taggedCount,
          qaClassName: label.canonicalTagName.split(' ')[0].toLowerCase()
        };
      });
    }

    get sortedToggledUserLabels() {
      let labels = null;

      if (!(0, _utils.isEmpty)(this.labelSearchString)) {
        labels = (0, _filterByFields.default)(this.sortedNonSystemLabels, ['tagName'], this.labelSearchString);
      } else if (this.showAllLabels) {
        labels = this.sortedNonSystemLabels;
      } else {
        labels = this.sortedNonSystemLabels.slice(0, _constants.MEDIA_LABEL_DEFAULT_DISPLAY_LIMIT);
      }

      return labels.map(label => {
        const labelId = label.id;
        return {
          id: labelId,
          selected: this.args.queryLabelIds.includes(parseInt(labelId)),
          canonicalTagName: label.canonicalTagName,
          taggedCount: label.taggedCount
        };
      });
    }

    get systemLabels() {
      var _this$groupLabels2;

      return (_this$groupLabels2 = this.groupLabels) === null || _this$groupLabels2 === void 0 ? void 0 : _this$groupLabels2.filter(label => label.isSystemLabel);
    }

    clearLabelSearch() {
      this.labelSearchString = undefined;
    }

    closeManageLabelsModal() {
      this.showManageLabelsModal = false;
    }

    openManageLabelsModal() {
      this.showManageLabelsModal = true;
    }

    toggleAllLabels() {
      this.showAllLabels = !this.showAllLabels;
    }

    toggleLabel(labelId) {
      if (this.args.queryLabelIds.includes(parseInt(labelId))) {
        this.args.removeQueryLabel(labelId);
      } else {
        this.args.addQueryLabel(labelId);
      }
    }

    toggleSocialProfile(socialProfileId) {
      if ((0, _utils.isBlank)(socialProfileId)) {
        this.args.clearQuerySocialProfile();
      } else if (this.args.querySocialProfileIds.includes(parseInt(socialProfileId.id))) {
        this.args.removeQuerySocialProfile(socialProfileId);
      } else {
        this.args.addQuerySocialProfile(socialProfileId);
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "labelSearchString", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "showAllLabels", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "showManageLabelsModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "sortedGroupLabels", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "sortedNonSystemLabels", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "sortedSystemLabels", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "clearLabelSearch", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearLabelSearch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeManageLabelsModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeManageLabelsModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openManageLabelsModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openManageLabelsModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleAllLabels", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleAllLabels"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleLabel", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSocialProfile", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSocialProfile"), _class.prototype)), _class));
  _exports.default = AssetFilterComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AssetFilterComponent);
});